export enum ReferenceType {
  ENFORCEMENT = "Enforcement",
  DEBT_SETTLEMENT = "DebtSettlement",
  SENTENCE = "Sentence",
}

export const REFERENCE_TYPE_OPTIONS = [
  { value: ReferenceType.ENFORCEMENT, label: "Enforcement" },
  { value: ReferenceType.DEBT_SETTLEMENT, label: "Debt Settlement" },
  { value: ReferenceType.SENTENCE, label: "Sentence" },
];
